import React, { useState } from "react";
import ReactDOM from "react-dom";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import ListGroup from "react-bootstrap/ListGroup";

//import { useTranslation } from "react-i18next";

import CommonConstants from "../service/CommonConstants";
import RemoteDataService from "../service/RemoteDataService";
import PoemsDataComponent from "./PoemsDataComponent";

export default function HeaderComponent(props) {
  //const [t, i18n] = useTranslation();
  const [poems, setPoems] = useState(null); //poems after the filter
  const [author, setAuthor] = useState(null); //author name
  const [authorID, setAuthorID] = useState(null); //author ID in database
  const [poemsInfo, setPoemsInfo] = useState(null); //how many poems and lines
  const [isYearOfPoem, setYearOfPoem] = useState(false); //is there year of poems
  const [optionsBooks, setFirstOptionsBook] = useState([]); //books for filter

  const allAuthors = CommonConstants.getAuthors();

  const setOptionsBooks = (books) => {
    books.forEach((value, key) => {
      optionsBooks.push(
        <option value={key} id={value + "_" + key} key={key}>
          {value}
        </option>
      );
    });
  };

  const handleSelectAuthor = () => {
    setPoems(null);
    setAuthor(null);
    setAuthorID(null);
    setPoemsInfo(null);
    setYearOfPoem(false);
    setFirstOptionsBook([]);
    ReactDOM.render(
      <PoemsDataComponent poems={null} withoutMessage={true} />,
      document.getElementById("tableResults")
    );
  };

  const handleSubmitAuthor = (e) => {
    let id = parseInt(e.target.id);
    setAuthorID(id);
    setAuthor(allAuthors.get(id));
    setOptionsBooks(CommonConstants.getAuthorsBooks(id));
    setPoemsInfo(CommonConstants.getInfoAuthorsCorpus(id));
    setYearOfPoem(CommonConstants.getIsYearInAuthorsBooks(id));
    ReactDOM.render(
      <PoemsDataComponent poems={null} withoutMessage={true} />,
      document.getElementById("tableResults")
    );
  };

  async function handleSubmitFilters(e) {
    e.preventDefault();

    ReactDOM.render(
      <PoemsDataComponent poems={null} />,
      document.getElementById("tableResults")
    );

    let maxNumberOfIcts = document.getElementById("maxNumberOfIcts").value;
    if (maxNumberOfIcts < 0) {
      maxNumberOfIcts = 0;
    }
    let numberOfFeet = document.getElementById("numberOfFeet").value;
    if (numberOfFeet < 0) {
      numberOfFeet = 0;
    }

    let year_writing = 0;
    if (isYearOfPoem) {
      year_writing = document.getElementById("poem_year").value;
      if (year_writing < 0) {
        year_writing = 0;
      }
    }

    //form request parameters
    let requestParams = {
      authorCode: authorID,
      bookCode:
        optionsBooks[document.getElementById("selectBook").selectedIndex].key,
      poem_year: year_writing,
      substringTitle: document.getElementById("substringTitle").value,
      meter: document.getElementById("selectMeter").value,
      maxNumberOfIcts: maxNumberOfIcts,
      lineMeter: document.getElementById("selectLineMeter").value,
      numberOfFeet: numberOfFeet,
      substring: document.getElementById("substring").value,
      subRepresentation: document.getElementById("subRepresentation").value,
      stropheType: document.getElementById("selectStrophsType").value,
      rhymeTypeInStrophe: document.getElementById("selectRhymeTypeInStrophe")
        .value,
      solidForm: document.getElementById("selectSolidForm").value,
      ending: document.getElementById("ending").value,
      rhymeKind: document.getElementById("selectRhymeKind").value,
      clause: document.getElementById("clause").value,
      grammaticalFormRhyme: document.getElementById(
        "selectGrammaticalFormRhyme"
      ).value,
      sortOfRhyme: document.getElementById("selectRhymeSort").value,
    };

    //request
    await RemoteDataService.getPoemsAndLines(requestParams).then((response) => {
      console.log("Status " + response.status + " was received.");
      if (response.status == 200) {
        setPoems(response.data);
        ReactDOM.render(
          <PoemsDataComponent poems={response.data} />,
          document.getElementById("tableResults")
        );
      }
    });
  }

  //poems meters
  const optionsMeters = [];
  const meters = CommonConstants.getPoemsMeters();
  meters.forEach((value) => {
    optionsMeters.push(
      <option value={value} id={"id" + value} key={value}>
        {value}
      </option>
    );
  });

  //lines meter
  const optionsLinesMeters = [];
  const metersLines = CommonConstants.getLinesMeters();
  metersLines.forEach((value) => {
    optionsLinesMeters.push(
      <option value={value} id={"id" + value} key={value}>
        {value}
      </option>
    );
  });

  //strophe types
  const optionsStrophsTypes = [];
  const strophesTypes = CommonConstants.getStropheType();
  strophesTypes.forEach((value) => {
    optionsStrophsTypes.push(
      <option value={value} id={"id" + value} key={value}>
        {value}
      </option>
    );
  });

  //rhyme type in strophe
  const optionsRhymeTypesInStrophe = [];
  const rhymeTypeInStrophes = CommonConstants.getRhymeTypeInStrophe();
  rhymeTypeInStrophes.forEach((value) => {
    optionsRhymeTypesInStrophe.push(
      <option value={value} id={"id" + value} key={value}>
        {value}
      </option>
    );
  });

  //solid forms
  const optionsSolidForms = [];
  const solidForms = CommonConstants.getSolidForms();
  solidForms.forEach((value) => {
    optionsSolidForms.push(
      <option value={value} id={"id" + value} key={value}>
        {value}
      </option>
    );
  });

  //kinds of rhymes
  const optionsRhymeKind = [];
  const rhymeKind = CommonConstants.getRhymeKind();
  rhymeKind.forEach((value) => {
    optionsRhymeKind.push(
      <option value={value} id={"id" + value} key={value}>
        {value}
      </option>
    );
  });

  //grammatical forms of rhymes
  const optionsGrammaticalFormsRhyme = [];
  const grammaticalFormsRhyme = CommonConstants.getGrammaticalFormOfRhyme();
  grammaticalFormsRhyme.forEach((value) => {
    optionsGrammaticalFormsRhyme.push(
      <option value={value} id={"id" + value} key={value}>
        {value}
      </option>
    );
  });

  //sort of rhymes
  const optionsSortOfRhymes = [];
  const sortOfRhymes = CommonConstants.getSortOfRhymes();
  sortOfRhymes.forEach((value) => {
    optionsSortOfRhymes.push(
      <option value={value} id={"id" + value} key={value}>
        {value}
      </option>
    );
  });

  const arrayAuthors = Array.from(allAuthors.keys());
  if (author === null) {
    return (
      <div>
        <h1>Выберите автора</h1>
        {arrayAuthors.map((breakpoint, idx) => (
          <ListGroup.Item
            variant="success"
            id={breakpoint}
            key={"author_" + idx}
            action
            onClick={handleSubmitAuthor}
          >
            {allAuthors.get(breakpoint)}
          </ListGroup.Item>
        ))}
      </div>
    );
  } else {
    let ableToSelectYear = "--- Отсутствует отбор по годам! ---";
    if (isYearOfPoem) {
      ableToSelectYear = "Год написания (например, 1970. Число > 0): ";
    }

    return (
      <div>
        <h1>
          {author}{" "}
          <Button variant="primary" type="button" onClick={handleSelectAuthor}>
            Назад к выбору автора
          </Button>
        </h1>
        <h2>
          Выберите искомое с помощью фильтров. Все фильтры действуют по принципу
          "И".
        </h2>
        <p>
          Всего {poemsInfo.get("NumberOfPoems")} стихотворений,{" "}
          {poemsInfo.get("NumberOfLines")} стихотворных строк.
        </p>
        <InputGroup className="filters">
          <form onSubmit={handleSubmitFilters}>
            <InputGroup.Text>
              Выбор публикации: <select id="selectBook">{optionsBooks}</select>
              {ableToSelectYear}
              <input type="number" id="poem_year" />
            </InputGroup.Text>
            <InputGroup.Text>
              Название, посвящение или эпиграф содержат слово:{" "}
              <input type="string" id="substringTitle" />
              Выбор стихотворного размера стихотворения:{" "}
              <select id="selectMeter">{optionsMeters}</select>
            </InputGroup.Text>
            <InputGroup.Text>
              Макс.число ударений в строке (число > 0):{" "}
              <input type="number" id="maxNumberOfIcts" />
            </InputGroup.Text>
            <InputGroup.Text>
              Выбор стихотворного размера строки:{" "}
              <select id="selectLineMeter">{optionsLinesMeters}</select>
              Число стоп для не-тонических (число > 0):{" "}
              <input type="number" id="numberOfFeet" />
            </InputGroup.Text>
            <InputGroup.Text>
              Стихотворная строка содержит символы (слово, часть слова):{" "}
              <input type="string" id="substring" />
              Представление строки содержит фрагмент (01010 и т.п.):{" "}
              <input type="string" id="subRepresentation" />
            </InputGroup.Text>
            <InputGroup.Text>
              Выбор типа строфы:{" "}
              <select id="selectStrophsType">{optionsStrophsTypes}</select>
              Выбор типа рифмовки в строфе:{" "}
              <select id="selectRhymeTypeInStrophe">
                {optionsRhymeTypesInStrophe}
              </select>
            </InputGroup.Text>
            <InputGroup.Text>
              Выбор твердой формы:{" "}
              <select id="selectSolidForm">{optionsSolidForms}</select>
            </InputGroup.Text>
            <InputGroup.Text>
              Окончание строки (1 - мужское, 10 - женское и т.п.):{" "}
              <input type="string" id="ending" />
              Выбор вида рифмы:{" "}
              <select id="selectRhymeKind">{optionsRhymeKind}</select>
              Выбор характера рифмы:{" "}
              <select id="selectRhymeSort">{optionsSortOfRhymes}</select>
            </InputGroup.Text>
            <InputGroup.Text>
              Клаузула (ой, ать и т.п.): <input type="string" id="clause" />
              Грамматическая форма рифменного слова:{" "}
              <select id="selectGrammaticalFormRhyme">
                {optionsGrammaticalFormsRhyme}
              </select>
            </InputGroup.Text>
            <Button variant="primary" type="submit">
              Получить результат
            </Button>
          </form>
        </InputGroup>
        <p>
          Если заметите ошибки или есть вопросы: mail to miropolskij@gmail.com
        </p>
      </div>
    );
  }
}
